import { RootState } from '@/store/types/RootState';

export const selectEntityDetails = (state: RootState) => state.entityDetails.entityDetails;
export const selectContactList = (state: RootState) => state.entityDetails.contactList;
export const selectIsContactListLoading = (state: RootState) =>
  state.entityDetails.dataRequestsStates.contactList.isLoading;
export const selectIsEntityDetailsLoading = (state: RootState) =>
  state.entityDetails.dataRequestsStates.entityDetails.isLoading;
export const selectIsAddressHistoryLoading = (state: RootState) =>
  state.entityDetails.dataRequestsStates.addressHistory.isLoading;
export const selectContactListPaginationRequest = (state: RootState) =>
  state.entityDetails.contactDetailsListPaginationRequest;
export const selectContactListPaginationResponse = (state: RootState) =>
  state.entityDetails.contactDetailsListPaginationResponse;
export const selectContactAddressHistoryById = (id: number) => (state: RootState) =>
  state.entityDetails.contactAddressHistories[id] ?? [];
